document.querySelectorAll('.faq-q').forEach(function(q){q.addEventListener('click',function(){var item=q.closest('.faq-item');var was=item.classList.contains('open');document.querySelectorAll('.faq-item.open').forEach(function(el){el.classList.remove('open')});if(!was)item.classList.add('open')})});
var io=new IntersectionObserver(function(e){e.forEach(function(en){if(en.isIntersecting){en.target.classList.add('vis');io.unobserve(en.target)}})},{threshold:.12});
document.querySelectorAll('.anim').forEach(function(el){io.observe(el)});
function runC(el){var target=parseFloat(el.dataset.target);var sfx=el.dataset.suffix||'';var pfx=el.dataset.prefix||'';var dec=parseInt(el.dataset.dec||0);var dur=1800;var st=performance.now();function upd(now){var prog=Math.min((now-st)/dur,1);var ease=1-Math.pow(1-prog,3);var val=target*ease;el.textContent=pfx+(dec?val.toFixed(dec):Math.floor(val))+sfx;if(prog<1)requestAnimationFrame(upd)}requestAnimationFrame(upd)}
var cio=new IntersectionObserver(function(e){e.forEach(function(en){if(en.isIntersecting){runC(en.target);cio.unobserve(en.target)}})},{threshold:.5});
document.querySelectorAll('.counter').forEach(function(el){cio.observe(el)});
var pio=new IntersectionObserver(function(e){e.forEach(function(en){if(en.isIntersecting){en.target.querySelectorAll('.pbar-fill').forEach(function(b){b.style.width=b.dataset.w+'%'});pio.unobserve(en.target)}})},{threshold:.15});
document.querySelectorAll('.ing-card-lg,.chart-wrap-hbar,.savings-compare').forEach(function(el){pio.observe(el)});

(function(){
  var popup=document.getElementById('bundlePopup');
  if(!popup)return;
  var already=false;
  try{already=sessionStorage.getItem('cdx_popup_shown')==='1'}catch(e){}
  if(already)return;
  var shown=false;
  function show(){
    if(shown)return;shown=true;
    popup.classList.add('show');
    try{sessionStorage.setItem('cdx_popup_shown','1')}catch(e){}
  }
  var t=setTimeout(show,14000);
  window.addEventListener('scroll',function(){
    if(window.scrollY>document.body.scrollHeight*0.4){show()}
  },{passive:true});
  document.querySelectorAll('.popup-close,.popup-dismiss').forEach(function(b){
    b.addEventListener('click',function(){popup.classList.remove('show');clearTimeout(t)})
  });
  popup.addEventListener('click',function(ev){if(ev.target===popup){popup.classList.remove('show')}});
})();

(function(){
  var floater=document.getElementById('promoFloater');
  if(!floater)return;
  var dismissed=false;
  try{dismissed=sessionStorage.getItem('cdx_floater_dismissed')==='1'}catch(e){}
  if(dismissed)return;
  setTimeout(function(){floater.classList.add('show')},5000);
  var closeBtn=floater.querySelector('.floater-close');
  if(closeBtn){
    closeBtn.addEventListener('click',function(){
      floater.classList.remove('show');
      try{sessionStorage.setItem('cdx_floater_dismissed','1')}catch(e){}
    });
  }
})();

(function(){
  var killSelectors=['[data-type="localization-form"]','.localization-form','.localization-selector','.localization-drawer','#shopify-section-announcement-bar','.country-selector','.currency-selector','.geolocation-modal','.geolocation-selector','#CountrySelector','#shopify-country-selector'];
  function sweep(){
    killSelectors.forEach(function(sel){
      try{document.querySelectorAll(sel).forEach(function(el){el.remove()})}catch(e){}
    });
    document.querySelectorAll('body > div, body > form').forEach(function(el){
      var txt=(el.textContent||'').trim();
      if(txt.length<60 && /Polish Złoty|Polski Złoty/i.test(txt)){el.remove()}
    });
  }
  sweep();
  try{
    var mo=new MutationObserver(sweep);
    mo.observe(document.body,{childList:true,subtree:true});
  }catch(e){}
})();

(function(){
  var targets=document.querySelectorAll('[data-countdown-target]');
  if(!targets.length)return;
  var deadline=new Date(targets[0].getAttribute('data-countdown-target')).getTime();
  function pad(n){return String(n).length<2?'0'+n:String(n)}
  function tick(){
    var now=Date.now();
    var diff=Math.max(0,deadline-now);
    var d=Math.floor(diff/86400000);
    var h=Math.floor((diff%86400000)/3600000);
    var m=Math.floor((diff%3600000)/60000);
    var s=Math.floor((diff%60000)/1000);
    document.querySelectorAll('[data-cd-d]').forEach(function(el){el.textContent=d});
    document.querySelectorAll('[data-cd-h]').forEach(function(el){el.textContent=pad(h)});
    document.querySelectorAll('[data-cd-m]').forEach(function(el){el.textContent=pad(m)});
    document.querySelectorAll('[data-cd-s]').forEach(function(el){el.textContent=pad(s)});
  }
  tick();
  setInterval(tick,1000);
})();
